import React from 'react'
import { Link, Outlet, useLocation, useParams } from 'react-router-dom'
import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import PageHeader from '../../../components/admin/PageHeader'
import StatusBadge from '../../../components/admin/StatusBadge'

export default function PlayerDetailLayout() {
  const { playerId } = useParams()
  const { pathname } = useLocation()
  const base = `/players/${playerId}`

  const tabs = [
    { label: 'Overview', to: `${base}/overview` },
    { label: 'Balances', to: `${base}/balances` },
    { label: 'Transactions', to: `${base}/transactions` },
    { label: 'Gameplay', to: `${base}/gameplay` },
    { label: 'Security', to: `${base}/security` },
    { label: 'Notes & tags', to: `${base}/notes-tags` },
    { label: 'KYC', to: `${base}/kyc` },
    { label: 'Compliance', to: `${base}/compliance` },
  ]

  return (
    <Box>
      <PageHeader
        title={`Player ${playerId}`}
        description="Balances, gameplay, risk, and compliance in one workspace."
        actions={<StatusBadge label="Account: review" tone="warning" />}
      />
      <Tabs
        value={pathname}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 2, minHeight: 40 }}
      >
        {tabs.map((t) => (
          <Tab key={t.to} label={t.label} component={Link} to={t.to} value={t.to} />
        ))}
      </Tabs>
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
        Each tab is a route for deep-linking and permissions.
      </Typography>
      <Outlet />
    </Box>
  )
}
